









































































import axios, { AxiosResponse, AxiosPromise } from "axios";
import FactRecordHolder from "@/models/Fact";
import { getGeoEntityByISO3 } from "@/models/GeoEntity.ts";
import { updateCentroid } from "@/models/GeoLocation.ts";
import Document from "@/models/Document";
import DocumentFactsTable from "./DocumentFactsTable.vue";
import DocumentParkingLotFactsTable from "./DocumentParkingLotFactsTable.vue";
import DocumentForm from "./DocumentForm.vue";
import FactQuickForm from "./FactQuickForm.vue";
import MasterFactAssociation from "./MasterFactAssociation.vue";
import EventAssociation from "./EventAssociation.vue";
import Map from "./Map.vue";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { Promise } from "ag-grid-community";

@Component({
  components: {
    DocumentForm,
    FactQuickForm,
    MasterFactAssociation,
    EventAssociation,
    Map,
    DocumentFactsTable,
    DocumentParkingLotFactsTable,
  },
})
export default class Scaffold extends Vue {
  @Prop() readonly id!: number;
  @Prop() readonly action!: string;

  private loading: boolean = false;
  private document: Document = new Document();
  private documentId: number | null = null;
  private parkingLotId: number | null = null;

  private loadingFact: boolean = false;
  private fact: FactRecordHolder | null = null;
  private factsTableVersion = 0;

  updateFactsTableVersion() {
    this.factsTableVersion++;
  }

  async created() {
    switch (this.action) {
      case "import":
        this.parkingLotId = this.id;
        await this.loadFromParkingLot();
        break;
      case "clone":
        this.documentId = this.id;
        await this.loadFromDocumentsAndClone();
        break;
      case "new":
        let document = new Document();
        delete document.id;
        this.document = document;
        break;
      default:
        this.documentId = this.id;
        await this.loadFromDocuments();
        break;
    }
  }

  async loadFromDocuments() {
    this.loading = true;
    try {
      const getDocument = axios.get("/psql/documents", {
        params: { id: `eq.${this.documentId}` },
        headers: { Accept: "application/vnd.pgrst.object+json" },
      });

      const getParkingLotDocument = axios.get("/psql/parking_lot", {
        params: { type: "eq.documents", imported_id: `eq.${this.documentId}` },
      });

      let [document, parkingLotDocument] = await axios.all([
        getDocument,
        getParkingLotDocument,
      ]);
      this.document = document.data;

      if (parkingLotDocument.data.length > 0) {
        this.parkingLotId = parkingLotDocument.data[0].id;
      }
      this.$toast.success("Document is loaded");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to load the document");
    }
    this.loading = false;
  }

  async loadFromParkingLot() {
    this.loading = true;
    try {
      let response = await axios.get("/psql/parking_lot", {
        params: { id: `eq.${this.parkingLotId}` },
        headers: { Accept: "application/vnd.pgrst.object+json" },
      });

      // cleanup
      delete response.data.data.publishers;
      this.document = { ...new Document(), ...response.data.data };
      this.$toast.success("Document is loaded from parking lot");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to load the document");
    }
    this.loading = false;
  }

  async loadFromDocumentsAndClone() {
    this.loading = true;
    try {
      let response: AxiosResponse = await axios.get("/psql/documents", {
        params: { id: `eq.${this.documentId}` },
        headers: { Accept: "application/vnd.pgrst.object+json" },
      });
      let document = response.data;
      delete document.id;
      // TODO: delete other fields!
      this.document = document;
      this.$toast.success("Document is loaded");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to load the document");
    }
    this.loading = false;
  }

  delete(id: number) {
    console.log(`Deleting ${id}`);
  }

  async saveDocument() {
    console.debug("saveDocument()", this.action);
    this.loading = true;
    let payload = { ...this.document };
    try {
      let response: AxiosResponse;
      if (this.action === "import") {
        delete payload.id;
        response = await this.saveDocumentRPC(payload, this.parkingLotId);
      } else {
        response = await this.saveDocumentRPC(payload, null);
      }
      this.$toast.success("Document is saved");
      let { id } = response.data;
      this.$router.push(`/scaffold/documents/${id}`);
    } catch (error) {
      console.error(error);
      console.error(error.response);
      this.$toast.error("Failed to save the document");
    }
    console.dir(this.document);
    this.loading = false;
  }

  async saveDocumentRPC(payload: any, parking_lot_id: number | null) {
    return axios.post(
      "/psql/rpc/helix_save_document",
      { payload, parking_lot_id },
      {
        headers: { Accept: "application/vnd.pgrst.object+json" },
      }
    );
  }

  cloneDocument() {
    this.$router.push(`/scaffold/documents/clone/${this.document.id}`);
  }

  async deleteDocument() {
    this.loading = true;
    try {
      let response = await axios.delete("/psql/documents", {
        params: { id: `eq.${this.documentId}` },
      });
      this.$toast.success("Document has been deleted");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to delete the document");
    }
    this.loading = false;
  }
}
